// Retarded name, but can't think of a better one
export const appendPositivitySign = (num?: number, separator: string = ''): string | undefined => {
  if (num === undefined) {
    return num
  }

  if (num < 0) {
    return String(num)
  }

  return `+${separator}${num}`
}

interface ToPercentageOptions {
  maxDecimalDigits?: number
  minDecimalDigits?: number
}

export const toPercentage = (
  fraction: number,
  { maxDecimalDigits = 0, minDecimalDigits = 0 }: ToPercentageOptions = {}
): string => {
  // Convert fraction to percentage
  const percentage = fraction * 100

  // Format the percentage string
  return (
    percentage.toLocaleString(undefined, {
      maximumFractionDigits: maxDecimalDigits,
      minimumFractionDigits: minDecimalDigits
    }) + ' %'
  )
}

export function toRoundToDecimalPlaces(number: number, fractionDigits?: number): number {
  return parseFloat(number.toFixed(fractionDigits))
}
